<template>
    <div class="google-static-map">
      <GmapMap
        ref="mapRef"
        :center="center"
        :zoom="15"
        :options="{
          mapTypeControl: true,
          streetViewControl: true,
          zoomControl: true,
          fullscreenControl: true,
          disableDefaultUi: false,
          rotateControl: true,
        }"
        style="width: 100%; height: 100%"
      >
        <GmapCustomMarker v-for="(m, index) in markers" :key="index" :marker="m.position">
          <div class="marker">
            <div
              class="marker__circle"
              v-tippy="{
                arrow: true,
                trigger: 'mouseenter focus',
                hideOnClick: false,
                theme: 'light',
                content: `
                <div style='text-align: left'>
                  <div>${m.number}</div>
                  <div>${getDate(m.ts)} at ${getTime(m.ts)}</div>
                </div>`,
              }"
              :style="{
                backgroundColor: m.color
              }"
            ></div>
            <div class="marker__pin"></div>
          </div>
        </GmapCustomMarker>
      </GmapMap>
    </div>
</template>

<script>
/* eslint-disable */
import GmapCustomMarker from "vue2-gmap-custom-marker";
import { mapGetters } from "vuex";
import { isEqual } from "lodash-es";

export default {
  name: "GoogleStaticMap",
  props: ["geography", "recipientId", "recipients"],
  components: {
    GmapCustomMarker,
  },
  data() {
    return {
      center: {
        lat: 41,
        lng: -71
      },
      markers: [],
      markerKeys: [],
    };
  },
  computed: {
    ...mapGetters("user", ["colors"]),
  },
  methods: {
      addMarker(geoLat, geoLng, ts, recipientId) {
        const marker = {
          lat: geoLat,
          lng: geoLng,
        };
        const recipient = this.recipients.find(i => i.recipient_id == recipientId);
        let color = "green";
        if (recipient) {
          if (recipient.recipient_id == this.recipientId) {
            color = "green";
          } else {
            const prevMarker = this.markers.find(m => m.number == recipient.number);
            if (prevMarker) {
              color = prevMarker.color;
            } else {
              const usedColors = this.markers.map(m => m.color);
              const colorNotUsed = this.colors.find(c => !usedColors.includes(c));
              color = colorNotUsed;
            }
          }
        }
        let number = recipient ? recipient.number : "";
        this.markerKeys.push(geoLat + "," + geoLng + "," + recipientId);
        this.markers.push({
          position: marker,
          ts,
          number,
          color,
          recipient_id: recipientId,
        });
      },
      getDate(ts) {
        return new Date(ts).toString().substring(4, 15);
      },
      getTime(ts) {
        return new Date(ts).toString().substring(16, 24);
      },
  },
  watch: {
    geography: {
      handler(geography) {
        geography.forEach((geog) => {
          if (!this.markerKeys.includes(geog.lat + "," + geog.lng + "," + geog.recipient_id)) {
            this.addMarker(geog.lat, geog.lng, geog.ts || geog.updated_at, geog.recipient_id);
          }
        });

        const lastGeoFromPrimaryRecipient = geography.find(geo => geo.recipient_id == this.recipientId);
        if (lastGeoFromPrimaryRecipient && !isEqual(lastGeoFromPrimaryRecipient, this.center)) {
          this.center = {...lastGeoFromPrimaryRecipient};
        }
      },
      deep: true,
      immediate: true,
    }
  },
};
</script>

<style lang="scss" scoped>
.marker {
  display: relative;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 30px;
  width: 25px;
  z-index: 998;

  &__circle {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -100%);
    height: 15px;
    width: 15px;
    border-radius: 100%;
    border: 2px solid white;
    box-shadow: 0 0 0 2px hsl(0, 0%, 80%), 0 0 0 3px hsl(0, 0%, 90%);
    z-index: 999;
  }

  &__pin {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 10%;
    height: 70%;
    background-color: white;
    box-shadow: 0 0 0 2px hsl(0, 0%, 80%), 0 0 0 3px hsl(0, 0%, 90%);
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
  }

  &.current &__circle {
    height: 25px;
    width: 25px;
  }

  &.current &__pin {
    width: 15%;
  }
}

#gmap-altimeter__container {
  display: none;
  position: absolute;
  left: 10px;
  top: 50px;
  width: 70px;
  min-height: 250px;
  height: 250px;
  z-index: 9999;
}

#gmap-altimeter {
  height: 250px !important;
}
</style>
